<script lang="ts">
  import { onMount } from "svelte";
  import FlexLayout from "../../layout/FlexLayout.svelte";
  import Chart from "svelte-frappe-charts";
  import { loadDashboard, tiles, numSubmissionsByDate, numTotalSubmissionsByClassroom, numSuccessfulSubmissionsByClassroom } from "./dashboard.store";

  onMount(loadDashboard);
</script>

<FlexLayout>
  <div class="dashboard-container">
    <div class="dashboard-sub-horiz">
      {#if !!$tiles}
        <div class="tile is-ancestor dashboard-tiles noselect">
          <div class="tile is-parent">
            <article class="tile is-child box has-text-centered dashboard-users">
              <p class="title is-size-1 dashboard-tile-text">{$tiles.numUsers}</p>
              <p class="subtitle dashboard-tile-text">users</p>
            </article>
          </div>
          <div class="tile is-parent">
            <article class="tile is-child box has-text-centered dashboard-classrooms">
              <p class="title is-size-1 dashboard-tile-text">{$tiles.numClassrooms}</p>
              <p class="subtitle dashboard-tile-text">classrooms</p>
            </article>
          </div>
          <div class="tile is-parent">
            <article class="tile is-child box has-text-centered dashboard-challenges">
              <p class="title is-size-1 dashboard-tile-text">{$tiles.numChallenges}</p>
              <p class="subtitle dashboard-tile-text">challenges</p>
            </article>
          </div>
          <div class="tile is-parent">
            <article class="tile is-child box has-text-centered dashboard-submissions">
              <p class="title is-size-1 dashboard-tile-text">{$tiles.numSubmissions}</p>
              <p class="subtitle dashboard-tile-text">submissions</p>
            </article>
          </div>
        </div>
      {/if}
    </div>

    <!--
    <div class="dashboard-sub-horiz scrollable" style="flex:1;">
      <div class="box chart-box">
        <h1 class="subtitle has-text-centered">Prossime cst per data di scadenza</h1>
        <Table loading={$expDossiersloading} fields={dashboardExpiringDossierDtoFields} records={$expDossiersRecords} />
      </div>
    </div>
    -->

    <div class="dashboard-sub-horiz" style="height:250px;">
      <div class="box chart-box chart-padding">
        <h1 class="subtitle has-text-centered">Number of submissions</h1>
        <Chart data={$numSubmissionsByDate} type="bar" colors={["#6fa132"]} animate={false} height="180" />
      </div>
    </div>

    <div class="dashboard-sub-horiz" style="height:250px;">
      <div class="box chart-box chart-padding">
        <h1 class="subtitle has-text-centered">Total submissions by classroom</h1>
        <Chart data={$numTotalSubmissionsByClassroom} type="donut" maxSlices="7" animate={false} height="180" />
      </div>

      <div class="box chart-box">
        <h1 class="subtitle has-text-centered">Successful submissions by classroom</h1>
        <Chart data={$numSuccessfulSubmissionsByClassroom} type="donut" maxSlices="7" animate={false} height="180" />
      </div>
    </div>

    <!--
      <div class="box chart-box">
        <h1 class="subtitle has-text-centered">
          CSTraining per causale (annuale)
        </h1>
        <Chart
          data={$dossiersByTypeYear}
          type="donut"
          maxSlices="7"
          animate={false}
          height="230"
        />
      </div>
      -->
    <!--
      <div class="box chart-box">
        <h1 class="subtitle has-text-centered">CSTraining per causale</h1>
        <Chart data={$dossiersByTypeGlobal} type="bar" maxSlices="7" animate={false} height="180" />
      </div>
          </div>
    -->
  </div>
</FlexLayout>

<style>
  .dashboard-container {
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
  }
  .dashboard-sub-horiz {
    display: flex;
    flex-direction: row;
    /*flex: 1;*/
    margin-bottom: 0.75rem;
  }
  .dashboard-tiles {
    /*margin-top: 1rem;*/
    padding: 0 0.75rem;
  }
  .dashboard-tile-text {
    color: #f8f8f8;
  }
  .dashboard-users {
    background-color: #6fa132;
  }
  .dashboard-classrooms {
    background-color: #6fa132;
  }
  .dashboard-challenges {
    background-color: #6fa132;
  }
  .dashboard-submissions {
    background-color: #6fa132;
  }
  .chart-box {
    /*height: 320px;*/
    /*overflow: hidden;*/
    flex: 1;
    padding-top: 1rem;
    /*padding-right: 1rem;*/
    margin: 0;
    max-width: 100%;
  }
  /*
  .scrollable {
    overflow-y: auto !important;
  }
  */
  .chart-padding {
    margin-right: 0.75rem;
  }
</style>
